import { SortDirection } from './SortableTableHeader';

/**
 * Compare two values of any type for sorting
 * 
 * @param aValue First value to compare
 * @param bValue Second value to compare
 * @param sortDirection Sort direction ('asc' or 'desc')
 * @returns Comparison result (-1, 0, or 1)
 */
export function compareValues(aValue: any, bValue: any, sortDirection: SortDirection): number {
    const multiplier = sortDirection === 'desc' ? 1 : -1;

    if (typeof aValue === 'string' && typeof bValue === 'string') {
        return multiplier * aValue.localeCompare(bValue);
    }

    if (aValue instanceof Date && bValue instanceof Date) {
        return multiplier * (aValue.getTime() - bValue.getTime());
    }

    return multiplier * ((aValue > bValue) ? 1 : (aValue < bValue) ? -1 : 0);
}
